import CenterContainer from './center-container.component';
export default CenterContainer;
